import React from 'react';
// import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import { useTranslation } from "react-i18next";

export default function CustomPhoneInput(props) {

  const { t } = useTranslation();
  const { value, onChange } = props;

  return (
    <PhoneInput
      defaultCountry="US"
      placeholder={t("common.phonePlaceholder")}
      value={value}
      onChange={onChange}/>
  );
};

CustomPhoneInput.propTypes = {};
CustomPhoneInput.defaultProps = {};
